import {inject, Injectable}                                     from '@angular/core';
import {TwColorType, TwTintType}                                from '@djsharkk/logr-types';
import {ChartDataset, ChartType, Point, ScriptableChartContext} from 'chart.js';
import {Context}                                                from 'chartjs-plugin-datalabels';
import * as patternomaly                                        from 'patternomaly';
import {UiThemeService}                                         from '../../logr-ui/utils/ui-theme.service';


export type ChartDatalabelFormatterType<T> = (v: T, c: Context) => string | number


@Injectable({
				providedIn: 'root'
			})
export class ChartThemeService {
	public svcUiTheme = inject(UiThemeService);


	/*
	 chartThemeGradientFill<TType extends ChartType = ChartType, TData = Point>(
	 ctx: ScriptableChartContext,
	 hover = false
	 ) {
	 const baseFill = config.type === 'bar' ? 0.4 : 0.2;
	 return this.checkGradient(ctx, [
	 config?.color?.dark || '#ff00ff'/!*this.svcUiTheme.getColorCode(
	 config.colorString,
	 config.type === 'bar' ? 600 : 950,
	 config.type === 'bar' ? (hover ? 0.25 : 0.15) : hover ? 0.2 : 0.1
	 )*!/,
	 config?.color?.base || '#ff00ff'/!*this.svcUiTheme.getColorCode(
	 config.colorString,
	 600,
	 config.type === 'bar' ? (hover ? 0.75 : 0.5) : hover ? 0.4 : 0.2
	 )*!/
	 ]);
	 }
	 */

	/*
	 chartThemeFillSolid<TType extends ChartType = ChartType, TData = Point>(
	 ctx: ScriptableChartContext,
	 config: ChartThemeIntf<TType, TData>,
	 hover = false
	 ) {
	 // const baseFill = config.type === 'bar' ? 0.4 : 0.2;
	 return config?.color?.alpha.base || '#ff00ff';
	 }*/

	chartThemeColors<TType extends ChartType = ChartType, TData = Point>(data: TData[]): ChartDataset<any> {
		return {
			fill              : true,
			barPercentage     : 0.95,
			categoryPercentage: 1,

			hoverBackgroundColor: '#ff00ff',
			backgroundColor     : '#ff00ff',

			borderSkipped  : 'bottom',
			borderColor    : '#ff00ff',//this.chartThemeColorsBorder(config),
			borderWidth    : '#ff00ff',
			borderCapStyle : 'round',
			borderJoinStyle: 'round',

			lineTension: 0.2,

			pointBackgroundColor     : '#ff00ff', //this.svcUiTheme.getColorCode(config.color, 600),
			pointHoverBackgroundColor: '#ff00ff', //this.svcUiTheme.getColorCode(config.color, 600),
			pointStyle               : 'circle',
			pointBorderColor         : '#ff00ff', //this.svcUiTheme.getColorCode(config.color, 600),
			pointBorderWidth         : 0,
			pointRadius              : 2.5,
			pointHitRadius           : 10,
			data
		} as ChartDataset;
	}


	checkGradient(
		context: ScriptableChartContext,
		colors?: string[],
		horizontal?: boolean
	) {
		const chart = context.chart;
		const {
				  ctx,
				  chartArea
			  } = chart;

		if (!chartArea) {
			return;
		}
		return this.buildRagGradient(ctx, chartArea, colors, horizontal);
	}

	buildRagGradient(
		ctx: CanvasRenderingContext2D,
		chartArea: {
			right: number;
			left: number;
			bottom: number;
			top: number;
		},
		colors?: string[],
		horizontal?: boolean
	) {
		const chartWidth = chartArea.right - chartArea.left;
		const chartHeight = chartArea.bottom - chartArea.top;

		let gradient: CanvasGradient;

		gradient = ctx.createLinearGradient(
			horizontal ? 0 : 0,
			horizontal ? 0 : chartArea.bottom,
			horizontal ? chartArea.right : 0,
			horizontal ? 0 : chartArea.top
		);

		if (colors) {
			colors.forEach((color, i) => {
				gradient.addColorStop((1 / colors.length) * i, color);
			});
		} else {
			gradient.addColorStop(0.0, this.svcUiTheme.getTailwindColor('lime', 600, 1));
			gradient.addColorStop(0.5, this.svcUiTheme.getTailwindColor('amber', 600, 1));
			gradient.addColorStop(1.0, this.svcUiTheme.getTailwindColor('rose', 600, 1));
		}

		return gradient;
	}

	buildPattern(colorL: TwColorType, colorD: TwColorType = colorL, tintL: TwTintType = 600, tintD: TwTintType = 900) {
		return patternomaly.draw(
			'diagonal',
			this.svcUiTheme.getTailwindColor(colorL, tintL),
			this.svcUiTheme.getTailwindColor(colorD, tintD),
			8
		)
	}


	mgFormatterY(context: Context) {
		const v = context.chart.data.datasets
						 .slice(1)
						 .reduce((accumulator, currentRecord) => (accumulator + (currentRecord.data[context.dataIndex] as Point)?.y || 0) as number, 0);
		return `${v.toFixed(0)}`;
	}





}